

export class MethodFromHashHelper {

    static methodRegistry: Record<string, (x:any) => void > = {
        "browserBack": () => {
            try {
                history.pushState(null, "", "#");
            } catch (err) {
                /*🤫*/
            }
        }
    }


    removeHashValueFromCurrentUrl() {
        try {
            history.pushState("", document.title, window.location.pathname);
        } catch (err) {
            /*🤫*/
        }

    }

    callMethodFromHash(hashValue: string) {
        const args = hashValue.split("&");
        const methodName = args[0];
        const params: Record<string, string> = {};

        args.slice(1).forEach(function (keyValuePair) {
            const parts = keyValuePair.split("=");
            const paramName = parts[0];
            params[paramName] = parts[1];
        });

        if (MethodFromHashHelper.methodRegistry[methodName]) {
            this.removeHashValueFromCurrentUrl();
            MethodFromHashHelper.methodRegistry[methodName](params);
        } else {
            console.error("Method '" + methodName + "' could not be found in registry");
        }
    }

    static initialize() {
        const o_order = window.o_order ?? {};
        o_order.methodFromHashHelper = o_order.methodFromHashHelper ?? new MethodFromHashHelper();
    }
}


